import { gql } from '@apollo/client';

export const fetchCampaignState = gql`
  query fetchCampaignState($campaignId: Long!) {
    campaign(id: $campaignId) {
      id
      campaignState
    }
  }
`;
